import { SingleNews } from '@toggle/toggle';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

export const useArticleDrawer = () => {
  const { params, deleteQueryParam, setQueryParams } = useQueryParams();

  const handleSelectSingleNews = (article: SingleNews) => {
    setQueryParams({
      [queryKeys.activeArticleId]: article?.id,
    });
  };

  const closeDrawer = () => {
    deleteQueryParam([queryKeys.activeArticleId]);
  };

  return {
    handleSelectSingleNews,
    closeDrawer,
    singleNewsId: params.activeArticleId,
  };
};
